// import Header from "./Header";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BannerSearch from "./BannerSearch";
// import SearchFilter from "./SearchFilter";
import LatestProperties from "./LatestProperties";
import WhoWeAre from "./Whoweare";
import Testimonials from "./Testimonials";
import { Helmet } from "react-helmet-async";
import PresidentMessages from "./PresidentMessages";
import PropertyVideo from "./PropertyVideo";
// import FinanceCalculator from './FinanceCalculator';
// import FeaturedProperties from "./FeaturedProperties";
// import CategorySection from "./CategorySection";
// import Footer from "./Footer";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#testimonials") {
      document
        .getElementById("testimonials")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  return (
    <>




















      <Helmet>
        <title>BG RealEstate360 | Industrial, Residential & Commercial Properties</title>
        <meta
          name="description"
          content="BG RealEstate360 offers verified industrial, residential and commercial properties in Ankleshwar. Buy, sell or rent plots, warehouses and factories with confidence."
        />
        <link rel="canonical" href="https://bgrealestate360.com/" />
      </Helmet>







      {/* <Header /> */}
      <BannerSearch />
      <WhoWeAre/>
      {/* < FinanceCalculator /> */}
      <LatestProperties />
    <PropertyVideo/>
      <Testimonials id="testimonial" />
       <PresidentMessages />
      {/* <SearchFilter /> */}

{/*    
      <FeaturedProperties /> */}
      {/* <CategorySection /> */}
     
    </>
  );
};

export default App;
